module.exports = __webpack_public_path__ + "img/hero.447b78ee.jpg";